import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const BranchRestrictionsLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./branch-restrictions'),
});
